import templateUrl from './transportation-bicycle-and-pedestrian.html';
import clone from 'lodash/clone';

export const transportationBicycleAndPedestrianComponent = {
	templateUrl,

	bindings: {
		details: '<'
	},

	controller: class TransportationBicycleAndPedestrianComponent {
		constructor(BicyclePedestrianService, $anchorScroll) {
			'ngInject';

			this.bicyclePedestrianService = BicyclePedestrianService;
			this.$anchorScroll = $anchorScroll;
		}

		$onInit() {
			this.details = this.bicyclePedestrianService.getBicyclePedestrianDetails(this.details);
			this.countyId = null;
			this.paginationDetails = {
				currentPage: 1,
				itemPerPage: 10,
				totalItems: this.details.count
			};

			this.filterDetails = {
				'limit': this.paginationDetails.itemPerPage,
				'pageId': this.paginationDetails.currentPage
			};
		}

		onChange(pageNumber) {
			this.paginationDetails.currentPage = pageNumber;
			this.filterDetails.limit = this.paginationDetails.itemPerPage;
			this.filterDetails.pageId = this.paginationDetails.currentPage;
			this.bicyclePedestrianService.getBicyclePedestrianFilterData({ id: this.countyId, filterDetails: this.filterDetails }).then(details => {
				this.details.details = details.details;
				this.paginationDetails = clone(this.paginationDetails);
				this.$anchorScroll(() => $location.hash());
			});
		}

		onCountyChange(ids) {
			this.countyId = ids;
			this.paginationDetails.currentPage = 1;
			this.filterDetails.pageId = this.paginationDetails.currentPage;
			this.bicyclePedestrianService.getBicyclePedestrianFilterData({ id: this.countyId, filterDetails: this.filterDetails }).then((details) => {
				this.details.details = details.details;
				this.paginationDetails.totalItems = details.count;
				this.paginationDetails = clone(this.paginationDetails);
			});
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/transportation-bicycle-and-pedestrian/transportation-bicycle-and-pedestrian.component.js